import { render, staticRenderFns } from "./CompletionCertificate.vue?vue&type=template&id=1cd0b726&scoped=true"
import script from "./CompletionCertificate.vue?vue&type=script&lang=js"
export * from "./CompletionCertificate.vue?vue&type=script&lang=js"
import style0 from "./CompletionCertificate.vue?vue&type=style&index=0&id=1cd0b726&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd0b726",
  null
  
)

export default component.exports